import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface CollectionOrderEditInfo {
  orderId: number // TODO 未確認
  holdingBranchCode: SystemCode
  mark: string
  ndc: string
  book: string
  sub: string
  shelfType: SystemCode
  collectionType: SystemCode
  traderCode: string
  donorCode: string
  orderDate: string
  orderPrice: number
  acceptType: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  revision: number
}

export function CollectionOrderEditInfoFromJSON(
  json: any
): CollectionOrderEditInfo {
  return {
    orderId: exists(json, 'order_id') ? json.order_id : 0,
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : '',
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    traderCode: exists(json, 'trader_code') ? json.trader_code : '',
    donorCode: exists(json, 'donor_code') ? json.donor_code : '',
    orderDate: exists(json, 'order_date')
      ? dateToPlainFormat(json.order_date)
      : '',
    orderPrice: exists(json, 'order_price') ? json.order_price : 0,
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
